var React = require('react');

function AudioPlay (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"43","cy":"43","r":"42","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M34.4 59V28l27 15.696L34.4 59z","fill":"#fff","key":1})]);
}

AudioPlay.defaultProps = {"width":"86","height":"86","fill":"none"};

module.exports = AudioPlay;

AudioPlay.default = AudioPlay;
